import React, { useEffect, useState, Component } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle, Mail } from 'lucide-react';
export function BookingForm() {
  const [isSuccess, setIsSuccess] = useState(false);
  // Check if we've returned from a successful FormSubmit redirect
  useEffect(() => {
    if (window.location.hash === '#booking-success') {
      setIsSuccess(true);
      // Clean up the hash
      window.history.replaceState(null, '', window.location.pathname + '#booking');
    }
  }, []);
  // Build a mailto fallback link with form context
  const mailtoLink = `mailto:alejandro@vitau.mx?subject=${encodeURIComponent('Booking Request — Texarkana')}&body=${encodeURIComponent("Hi Texarkana,\n\nI'd like to book you for an event.\n\nName: \nEmail: \nPhone: \nEvent Type: \nEvent Date: \nVenue/Location: \nExpected Guests: \nDetails: \n")}`;
  const inputClasses = 'w-full bg-tx-primary border border-tx-border px-4 py-3 text-tx-cream font-body focus:outline-none focus:border-tx-red focus:ring-1 focus:ring-tx-red transition-colors placeholder:text-tx-cream/30';
  const labelClasses = 'block font-heading text-xl tracking-wider text-tx-cream/80 mb-2';
  // Get the current page URL for redirect after submission
  const redirectUrl = typeof window !== 'undefined' ? window.location.origin + window.location.pathname + '#booking-success' : '#booking-success';
  return <Section id="booking" className="bg-tx-secondary border-t border-tx-border relative overflow-hidden" data-id="element-29">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-tx-primary/30 -skew-x-12 translate-x-32 pointer-events-none" data-id="element-30"></div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 relative z-10" data-id="element-31">
        <div className="lg:col-span-2" data-id="element-32">
          <h2 className="text-5xl md:text-7xl text-tx-cream mb-6 leading-none" data-id="element-33">
            Book <span className="text-tx-red" data-id="element-34">Texarkana</span>
            <br data-id="element-35" />
            For Your Event
          </h2>
          <div className="w-16 h-1 bg-tx-gold mb-8" data-id="element-36"></div>
          <p className="text-xl text-tx-cream/80 font-body leading-relaxed mb-8" data-id="element-37">
            Weddings, private parties, festivals, corporate events — we bring
            the show to you. Fill out the form with your event details and we'll
            get back to you with availability and pricing.
          </p>
          <div className="p-6 bg-tx-primary border border-tx-border" data-id="element-38">
            <p className="font-heading text-2xl text-tx-gold tracking-widest mb-2" data-id="element-39">
              NOTE:
            </p>
            <p className="text-tx-cream/70 font-body mb-4" data-id="element-40">
              We typically respond within 24 hours. For urgent inquiries, please
              include "URGENT" in your message.
            </p>
            <a href={mailtoLink} className="inline-flex items-center gap-2 text-tx-red hover:text-tx-cream font-heading text-lg tracking-wider transition-colors" data-id="element-41">
              <Mail className="w-5 h-5" data-id="element-42" />
              Or email us directly
            </a>
          </div>
        </div>

        <div className="lg:col-span-3" data-id="element-43">
          {isSuccess ? <div className="bg-tx-primary border border-tx-border p-12 flex flex-col items-center justify-center text-center h-full min-h-[400px]" data-id="element-44">
              <CheckCircle className="w-20 h-20 text-tx-red mb-6" data-id="element-45" />
              <h3 className="font-heading text-4xl text-tx-cream tracking-wider mb-4" data-id="element-46">
                Request Sent
              </h3>
              <p className="text-tx-cream/70 font-body text-lg" data-id="element-47">
                Thanks for reaching out. We've received your booking request and
                will be in touch shortly.
              </p>
              <Button className="mt-8" variant="outline" onClick={() => setIsSuccess(false)} data-id="element-48">
                Send Another Request
              </Button>
            </div> : <form action="https://formsubmit.co/alejandro@vitau.mx" method="POST" className="bg-tx-primary border border-tx-border p-6 md:p-10 space-y-6 shadow-2xl" data-id="element-49">
              {/* FormSubmit config */}
              <input type="hidden" name="_subject" value="New Booking Request — Texarkana" data-id="element-50" />
              <input type="hidden" name="_template" value="table" data-id="element-51" />
              <input type="hidden" name="_captcha" value="false" data-id="element-52" />
              <input type="hidden" name="_next" value={redirectUrl} data-id="element-53" />
              <input type="text" name="_honey" style={{
            display: 'none'
          }} data-id="element-54" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-55">
                <div data-id="element-56">
                  <label htmlFor="name" className={labelClasses} data-id="element-57">
                    Name
                  </label>
                  <input type="text" id="name" name="name" required className={inputClasses} placeholder="John Doe" data-id="element-58" />
                </div>
                <div data-id="element-59">
                  <label htmlFor="email" className={labelClasses} data-id="element-60">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required className={inputClasses} placeholder="john@example.com" data-id="element-61" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-62">
                <div data-id="element-63">
                  <label htmlFor="phone" className={labelClasses} data-id="element-64">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" className={inputClasses} placeholder="(555) 123-4567" data-id="element-65" />
                </div>
                <div data-id="element-66">
                  <label htmlFor="eventType" className={labelClasses} data-id="element-67">
                    Event Type
                  </label>
                  <select id="eventType" name="event_type" required className={`${inputClasses} appearance-none`} data-id="element-68">
                    <option value="" disabled selected data-id="element-69">
                      Select an event type
                    </option>
                    <option value="Wedding" data-id="element-70">Wedding</option>
                    <option value="Private Party" data-id="element-71">Private Party</option>
                    <option value="Festival" data-id="element-72">Festival</option>
                    <option value="Corporate Event" data-id="element-73">Corporate Event</option>
                    <option value="Bar/Restaurant" data-id="element-74">Bar/Restaurant</option>
                    <option value="Other" data-id="element-75">Other</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-76">
                <div data-id="element-77">
                  <label htmlFor="date" className={labelClasses} data-id="element-78">
                    Event Date
                  </label>
                  <input type="date" id="date" name="event_date" required className={inputClasses} data-id="element-79" />
                </div>
                <div data-id="element-80">
                  <label htmlFor="guests" className={labelClasses} data-id="element-81">
                    Expected Guests
                  </label>
                  <input type="number" id="guests" name="expected_guests" className={inputClasses} placeholder="150" data-id="element-82" />
                </div>
              </div>

              <div data-id="element-83">
                <label htmlFor="venue" className={labelClasses} data-id="element-84">
                  Venue / Location
                </label>
                <input type="text" id="venue" name="venue_location" required className={inputClasses} placeholder="City, State or Venue Name" data-id="element-85" />
              </div>

              <div data-id="element-86">
                <label htmlFor="message" className={labelClasses} data-id="element-87">
                  Message / Details
                </label>
                <textarea id="message" name="message" rows={4} className={`${inputClasses} resize-none`} placeholder="Tell us more about your event..." data-id="element-88"></textarea>
              </div>

              <Button type="submit" size="lg" className="w-full mt-4" data-id="element-89">
                Submit Booking Request
              </Button>
            </form>}
        </div>
      </div>
    </Section>;
}